import React from "react";
import PostDate from "./PostDate";
import styled from "styled-components";

const DateP = styled.p`
  text-align: right;
`;

const PostHeader = ({ post }) => {
  return (
    <header>
      <DateP className="light">
        <PostDate date={post.frontmatter.date} />
      </DateP>
      <h1>{post.frontmatter.title}</h1>
    </header>
  );
};

export default PostHeader;
